import { useLocale, useTranslations } from "@acto/web-common/locales";
import { ProductExclusionReason } from "@acto/gql/graphql";
import type { ProductExclusion } from "@acto/taskpane/core/domain";
import { hideDurationLabel } from "./hideDurationLabel";
import type { HiddenProductView } from "./HiddenProductsDisclosure";

export function useHiddenProductViews(
  exclusions: ProductExclusion[],
  fallbackNames?: ReadonlyMap<string, string>,
): HiddenProductView[] {
  const t = useTranslations("fieldSalesTwo.genuiMeetingPrep.productHide");
  const { locale } = useLocale();

  return exclusions.map((exclusion) => ({
    id: exclusion.id,
    name: exclusion.name(locale) ?? fallbackNames?.get(exclusion.productId) ?? exclusion.productId,
    metaLabel: [
      exclusion.reason === ProductExclusionReason.DataIncorrect
        ? t("reasonDataIncorrect")
        : t("hiddenReasonNotSuitable"),
      hideDurationLabel(exclusion.duration(), t, locale),
    ].join(" · "),
  }));
}
